<template>
    <div class="inner-box">
        <h2 class="title">{{title}}</h2>
        <div style="height:55px;"></div>
        <table class="visit-info-table">
            <tr>
                <th style="width:80px;">제목</th>
                <td>{{form.subject}}</td>
            </tr>
            <tr>
                <th>등록일</th>
                <td>{{form.regDtm}}</td>
            </tr>
            <tr>
                <th>내용</th>
                <td>
                    <vue-editor v-model="form.content" :disabled=true />
                </td>
            </tr>
        </table>
        <div class="btn">
            <button @click="deleteDoc()">삭제</button>
            <button @click="modify()">수정</button>
            <button @click="moveToList()">목록</button>
        </div>
    </div>
</template>

<script>
    import {VueEditor} from "vue2-editor"

    export default {
        name: 'TermsDetail',
        components: { VueEditor },
        props: {
            contentId: {
                type: String,
                required: false
            },
        },
        data(){
            return {
                title: "신청약관",
                authority: '',
                form: {
                    subject: '',
                    writer: null,
                    content: '',
                    regDtm: '',
                    chgDtm: '',
                }
            }
        },
        created() {
          //Admin 권한 체크
          if(this.$store.state.loginInfo.authorities[0].roleCd != "ADMIN") {
            setTimeout(()=> {
              this.$swal({type: 'warning', text: '관리자만 접속 가능합니다.'})
                  ,100});
            this.$router.push({path: `/ijmt`});
          };
        },
        methods: {
            getContentItems(contentId) {
                this.$http.post(`/api/terms/detail`, { id: contentId })
                    .then(response => {
                        this.form.subject = response.data.subject;
                        this.form.content = response.data.content;
                        this.form.regDtm = response.data.regDtm;
                        this.form.chgDtm = response.data.chgDtm;
                    });
            },
            modify(){
                this.$router.push({name: `termsCreate`, params:{contentId: this.contentId}});
            },
            deleteDoc(){
                this.$swal({
                    type: 'question',
                    text: `삭제하시겠습니까?`,
                    showCancelButton: true,
                    confirmButtonText: '예',
                    cancelButtonText: '아니오',
                }).then((result) => {
                    if (result.value) {
                        this.$http.post(`/api/terms/delete`, { id: this.caontentId });
                        this.$router.push({name: `termsListMng`});
                    }
                });
            },
            moveToList(){
                this.$router.push({name: `termsListMng`});
            }
        },
        mounted() {
            $('.ql-toolbar.ql-snow').css({
                "display": "none",
            });
            $('.ql-container.ql-snow').css({
                "border": "none"
            });
            this.getContentItems(this.contentId);
            this.authority = this.$store.state.loginInfo.authorities[0].roleCd;
        }
    }
</script>

<style lang="scss" scoped>
    @import "public/css/bulma";

    .inner-box{
        height: 100%;
        width:95%;
        left: 0;
        right: 0;
        margin: 0 auto 30px;
    }

    @media (min-width: 1000px) {
        .inner-box{
            width:1000px;
        }
    }

    .title{
        font-size:40px;
        text-align:center;
        margin-top:50px;
    }

    .title-s{
        font-size:15px;
        color:#666;
        text-align:center;
        padding:0 0 30px 0;
    }

    .inner-box h1{
        font-size:20px;
        padding:50px 0 10px 0;
        font-weight: bold;
    }

    .inner-box ul{
        top: 30px;
        width: 100%;
        height: 60px;
        border:1px solid #d5d5d5;
    }

    .inner-box ul li{
        float: left;
        width: 33.3%;
        color: #888;
        text-align: center;
        display: block;
        line-height: 58px;
        font-weight: 700;
        border-right:1px solid #d5d5d5
    }

    .inner-box ul li:last-child{
        border-right:0;
    }

    .inner-box .on{
        background-color: #023e7c;
        color:#fff;
    }

    table.visit-info-table{
        border-top: 1px solid #aaaaaa;
        width: 100%;
    }

    table.visit-info-table td {
        border-bottom: 1px solid #ddd;
        color: #999;
        padding: 15px 0 15px 10px;
        font-size: 14px;
        vertical-align: middle;
    }

    table.visit-info-table th {
        border-bottom: 1px solid #ddd;
        color: #666;
        padding: 15px 10px 15px 10px;
        font-size: 14px;
        vertical-align: middle;
        background: #f9f9f9;
        text-align: center;
    }

    table.visit-info-table td input{
        width: 35%;
    }

    table.visit-info-table td p input{
        width: 100%;
    }

    table.visit-info-table td select{
        padding:10px 40px 10px 15px;
    }

    table.visit-info-table td.tit{
        background: #f9f9f9;
        padding-left: 30px;
        color: #666;
        line-height: normal;
    }

    table.visit-info-table td.tit-c{
        background: #f9f9f9;
        color: #666;
        line-height: normal;
        text-align: center;
    }

    table.visit-info-table td.list-c{
        text-align: center;
    }

    table.visit-info-table td button{
        margin-left:10px;
    }

    .inner-box button{
        margin:15px 5px;
        padding:10px;
        border:1px solid #d5d5d5;
        text-align:center;
    }

    .inner-box .btn{
        text-align:center;
    }

    .inner-box button:last-child{
        background-color: #b3b3b3;
        color:#fff;
    }

    .ql-toolbar.ql-snow{
        display: none;
        border: none;
    }
</style>